import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { Endpoints } from "../../const/Api";
import { RootState } from "../../store";
import { client } from "../../tool/client";
import {
  endAuto,
  finishAnimation,
  forcefinishAuto,
  resetResult,
  sendAutoBetAction,
  setLastPeriodFromApi,
} from "../result/reducer";
import { History, HistoryFull } from "./type";

interface InitialState {
  current_round: number;

  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null | undefined;
  data: HistoryFull[];
  last_history: History[];
  viewAll: boolean;
}

const historyAdapter = createEntityAdapter<History>({
  selectId: (history) => history.round_id,
  sortComparer: (a, b) => b.round_id - a.round_id,
});

const initialState: InitialState = {
  current_round: 1,
  status: "idle",
  error: null,
  data: [],
  last_history: [],
  viewAll: false,
};

let domain: any;

export const fetchHistory = createAsyncThunk(
  "history/fetchHistory",
  async () => {
    const response = await new Promise((r, rj) => {
      setTimeout(async () => {
        try {
          domain = domain || (await (await fetch(Endpoints.Domain)).json());

          const response = await client.get(domain.history);
          if (!response.data.data) {
            rj("data history empty");
          }
          r(response);
        } catch (error) {}
      }, 1000);
    });

    return (response as any).data.data;
  }
);
let i: any;
export const refreshHistory = createAsyncThunk(
  "history/refreshHistory",
  async (auto: boolean, { dispatch, getState }: any) => {
    const state: any = getState();
    let v: any = 0;
    let last_round: any;

    if (auto) {
      setTimeout(async () => {
        // domain = domain || (await (await fetch(Endpoints.Domain)).json());

        // const last_periode = await await client.get(
        //   `${domain.realtime_last_history}?user_id=${
        //     getState().auth.player.player_id
        //   }&operatorId=${getState().auth.player.agent_id}&gameId=${"PLK00001"}`
        // );

        last_round =   getState().result.payload[getState().result.singleCount]
                  .last_bet.button_bet.round_id + 1;
        dispatch(
          sendAutoBetAction({
            ...getState().result.payload[getState().result.singleCount]
              .last_bet,
            button_bet: {
              ...getState().result.payload[getState().result.singleCount]
                .last_bet.button_bet,
              round_id:last_round
              ,
            },
            round_id:
              last_round,
          })
        );
        dispatch(
          setLastPeriodFromApi(
            last_round
          )
        );
      }, 250);
    } else {
    }

    const response = await new Promise((r, rj) => {
      setTimeout(async () => {
        // if (!auto) {
        //   domain = domain || (await (await fetch(Endpoints.Domain)).json());
        //   const response = await client.get(domain.history);

        //   if (!response.data.data) {
        //     rj("data history empty");
        //   }
        //   r(response);
        // }else{
        r(null);
        // }
      }, 0);
    });

    return {
      data: (response as any).data.data,
      auto: auto,
      last_round: auto
        ? last_round
        : getState().result.payload[getState().result.singleCount].last_bet
            .button_bet.round_id + 1,
    };
  }
);

export const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    addedHistory: (state, action: PayloadAction<History>) => {
      // historyAdapter.addOne(state, action.payload)
      // state.data = [...state.data, action.payload]
    },
    addedLastHistory: (state, action: PayloadAction<History>) => {
      const createNewDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedDate;
      };
      const newDataDate = state.data.filter(
        (item) => item.round_id == action.payload.round_id
      ).length
        ? state.data.filter((item) => item.round_id == action.payload.round_id)
        : createNewDate();
      state.last_history = [
        ...state.last_history,
        { ...action.payload, created_date: newDataDate + "" },
      ];
      // historyAdapter.addOne(state, action.payload)
    },
    clearLastHistory: (state, action: PayloadAction) => {
      // historyAdapter.addOne(state, action.payload)
      state.last_history = [];
    },
    closeViewAll: (state, action: PayloadAction) => {
      state.viewAll = false;
    },
    openViewAll: (state, action: PayloadAction) => {
      state.viewAll = true;
      // state.viewAll = !state.viewAll ;
    },
    newRound: (state, action: PayloadAction) => {
      state.current_round = state.current_round + 1;
      // state.viewAll = !state.viewAll ;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchHistory.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(
        fetchHistory.fulfilled,
        (state, action: PayloadAction<HistoryFull[]>) => {
          state.status = "succeeded";

          const lastHistory = action.payload[0];
          if (lastHistory) {
            state.current_round = lastHistory.round_id + 1;
          }

          state.data = action.payload;
        }
      )
      .addCase(fetchHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(
        refreshHistory.fulfilled,
        (
          state,
          action: PayloadAction<{
            data: HistoryFull[];
            auto: boolean;
            last_round: number;
          }>
        ) => {
          state.status = "succeeded";

          const lastHistory = action.payload.data
            ? action.payload.data[0]
            : null;

          if (action.payload.auto) {
            if (state.current_round < action.payload.last_round) {
              state.current_round = action.payload.last_round;
            }
          }
          if (lastHistory) {
            // state.current_round = lastHistory.round_id + 1;
            if (
              !action.payload.auto &&
              state.current_round < lastHistory.round_id + 1
            ) {
              state.current_round = lastHistory.round_id + 1;
            }

            if (
              !action.payload.auto &&
              state.current_round > lastHistory.round_id + 1
            ) {
              state.current_round = lastHistory.round_id + 1;
            }
          }
          if (action.payload.data) {
            state.data = action.payload.data;
          }
        }
      );
  },
});

export const {
  addedHistory,
  clearLastHistory,
  addedLastHistory,
  openViewAll,
  newRound,
  closeViewAll,
} = historySlice.actions;

export default historySlice.reducer;
